import { useState } from 'react'

import {
    AreaInspection,
    Attachment,
    CustomStatus,
    IdentifiableObject,
    InventoryConfig,
} from '../models'
import { axiosInstance } from '../helpers'

export const useFlagInventoryInspections = () => {
    const [flagInventoryInspections, setFlagInventoryInspections] = useState<
        FlagInventoryInspectionData[]
    >([])

    const getFlagInventoryInspections = async (inspectionId?: number) => {
        try {
            const response = await axiosInstance.get(
                'inspection/inventory-inspection/get_flag_inventory_inspections/',
                {
                    params: {
                        inspection: inspectionId,
                    },
                },
            )
            const data: FlagInventoryInspectionData[] = response.data
            setFlagInventoryInspections(data)
            return data
        } catch (error) {
            console.error('Error getting flag inventory inspections:', error)
            return Promise.reject(error)
        }
    }

    const updateInvInsState = (invIns: FlagInventoryInspectionData) => {
        setFlagInventoryInspections((prev) =>
            prev.map((item) => (item.id === invIns.id ? invIns : item)),
        )
    }

    return {
        flagInventoryInspections,
        getFlagInventoryInspections,
        updateInvInsState,
    }
}

export interface FlagInventoryInspectionData extends IdentifiableObject {
    status: CustomStatus
    inventory_config: InventoryConfig
    area_inspection: AreaInspection
    channel: number | null
    handled: boolean
    workorder_ids: number[]
    attachments: Attachment[]
}
